import { render, staticRenderFns } from "./ViewCalculationResults.vue?vue&type=template&id=ca0b022c&scoped=true"
import script from "./ViewCalculationResults.vue?vue&type=script&lang=js"
export * from "./ViewCalculationResults.vue?vue&type=script&lang=js"
import style0 from "./ViewCalculationResults.vue?vue&type=style&index=0&id=ca0b022c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0b022c",
  null
  
)

export default component.exports